import _, { flatMap, isObject, keys } from 'lodash'

export function customizer(objValue: any, srcValue: any) {
  return _.isUndefined(objValue) ? srcValue : objValue
}

export function getKeysAtLevel(
  obj: any,
  targetLevel: number,
  currentLevel = 1
): string[] {
  if (!isObject(obj) || currentLevel > targetLevel) return []

  if (currentLevel === targetLevel) {
    return keys(obj)
  }

  return flatMap(obj, (value) =>
    getKeysAtLevel(value, targetLevel, currentLevel + 1)
  )
}
